import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Card from 'reactstrap/lib/Card';
import Button from 'reactstrap/lib/Button';
import { getPriceString } from 'site-modules/shared/utils/price-utils';
import { srpLinkBuilder } from 'site-modules/shared/utils/srp-link-constructor';
import { Link } from 'site-modules/shared/components/link/link';

import './trim-card.scss';

export function TrimCard({
  onRemoveTrim,
  makeSlug = null,
  modelSlug = null,
  modelName = null,
  year = null,
  trimName = null,
  engine = null,
  baseMSRP = null,
  esp = null,
  inventoryCount = null,
  isRecommended = false,
  isUsed = false,
  isSticky = false,
}) {
  const [isRemoving, setRemoving] = useState(false);
  function removeTrim() {
    setRemoving(true);
    setTimeout(() => {
      onRemoveTrim(trimName);
      setRemoving(false);
    });
  }

  return (
    <Card
      className={classnames(
        'h-100 justify-content-end align-items-center text-center trim-card rounded-12 px-1 px-md-0_5 px-lg-1 pb-1',
        { 'recommended pt-0_5': isRecommended, 'pt-1': !isRecommended, removing: isRemoving }
      )}
    >
      {isRecommended && <div className="mb-0_25 text-center medium fw-medium text-blue-40">Editors&apos; Pick</div>}
      <div className={classnames('mb-0_25', { 'heading-3': !isSticky, 'heading-4': isSticky })}>{trimName}</div>
      <div className={classnames('medium', { 'mb-1_5': !isSticky })}>{engine}</div>
      {!isSticky && (
        <Fragment>
          {!isUsed && (
            <dl className="w-100 d-flex justify-content-between mb-0_5">
              <div className="d-flex flex-column text-start">
                <dt className="small">Starting MSRP</dt>
                <dd className="size-16 fw-medium">{getPriceString(baseMSRP)}</dd>
              </div>
              <div className="d-flex flex-column text-end">
                <dt className="small">Avg Price Paid</dt>
                <dd className="size-16 fw-medium">{getPriceString(esp)}</dd>
              </div>
            </dl>
          )}
          <Button
            tag={Link}
            color="blue-50"
            size="lg"
            className={classnames('w-100 px-1 py-0_5 text-transform-none text-decoration-none fw-normal rounded-8', {
              'mb-0_5': inventoryCount,
              'mb-1_5': !inventoryCount,
            })}
            to={srpLinkBuilder({
              make: makeSlug,
              model: modelSlug,
              year,
              trim: trimName,
            })}
            data-tracking-id="trim_cards_srp_button"
            data-tracking-value="See all for sale"
          >
            See all
            <span className="visually-hidden">
              {' '}
              {modelName} {trimName}
            </span>{' '}
            for sale
          </Button>
          {!!inventoryCount && (
            <div className="small text-primary-darker fst-italic">{inventoryCount} for sale near you</div>
          )}
        </Fragment>
      )}
      {!isRemoving && (
        <Button
          onClick={removeTrim}
          color="link"
          size="lg"
          className="remove-button pos-a top-0 right-0 mt-0_5 me-0_5 p-0_25 fw-normal"
          data-tracking-id="remove_trim"
          data-tracking-value={trimName}
        >
          <span className="visually-hidden">Remove {trimName} from comparison</span>
          <i className="icon-cross2" aria-hidden />
        </Button>
      )}
    </Card>
  );
}

TrimCard.propTypes = {
  onRemoveTrim: PropTypes.func.isRequired,
  makeSlug: PropTypes.string,
  modelSlug: PropTypes.string,
  modelName: PropTypes.string,
  year: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  trimName: PropTypes.string,
  engine: PropTypes.string,
  baseMSRP: PropTypes.number,
  esp: PropTypes.number,
  inventoryCount: PropTypes.number,
  isRecommended: PropTypes.bool,
  isUsed: PropTypes.bool,
  isSticky: PropTypes.bool,
};
